import { Bus } from '@common/bus';
import { useMixpanel } from '@common/composables/useMixpanel.js';
import { alertError, alertInfo } from '@common/utils/alert';
import { scrollToTop } from '@common/utils/dom';
export const MMSErrorHandler = (error, router) => {
  const { response } = error;

  if (!response) {
    return;
  }
  const { mixpanelTrackEvent } = useMixpanel();

  const config = response?.config || {};

  const { method = '', url = '' } = config;

  const [baseUrl, query = ''] = url.split('?');

  mixpanelTrackEvent(
    'MMS API Error',
    {
      code: response?.status || '',
      errorCode: response?.headers?.error_code || '',
      errorDescription: response?.data?.message || '',
      fullRequestUrl: url,
      requestQuery: query,
      requestType: method,
      requestUrl: baseUrl,
    },
    router.currentRoute.value
  );
  switch (response.status) {
    case 401:
      window.location.href = '/login';
      break;
    case 403:
      alertError('You are not authorized to perform this action.');
      break;

    case 404:
      router.replace({ path: '/404' });
      break;

    case 419:
      alertInfo('Your session has expired. Please click Ok to refresh the page', () => {
        window.location.reload();
      });
      break;

    case 423: // Locked exception
      alertError('Please try again');
      return;

    case 500:
      alertError('Something went wrong!');
      break;

    case 503:

    case 520:
      alertError("We couldn't complete your request at the moment, please try again.");
      Bus.$emit('form-modal:stop-saving');
      break;

    case 504:
      alertError('Sorry, we couldn’t serve your request');
      break;
  }
  scrollToTop();
};
